import { Frequency, Source, Ticker } from 'types'
import { Model } from 'types/models'
import {
  EndpointDefinitionNotRequiringZipping,
  ModelParametersSpecifiedTimestampParams,
  getBSData,
} from './common'
import { DataFrequency } from './dataService'

const OPTIONS_HEATMAP_ENDPOINT: EndpointDefinitionNotRequiringZipping = {
  path: 'timeseries/getOptionsHeatMapData',
  itemsRequireZipping: false,
}

export type OptionsHeatmapItem = {
  expiry: number
  strike: string
  timeseries: {
    series: string
    field: string
    start: string
    end: string
  }
  timestamp: number
  value: number
  zscore: number
}

const isOptionsHeatmapItem = (item: any): item is OptionsHeatmapItem => {
  return (
    !!item &&
    item.expiry !== undefined &&
    !Number.isNaN(item.expiry) &&
    item.strike !== undefined &&
    typeof item.strike === 'string' &&
    item.timestamp !== undefined &&
    !Number.isNaN(item.timestamp) &&
    item.value !== undefined &&
    !Number.isNaN(item.value) &&
    item.zscore !== undefined &&
    !Number.isNaN(item.zscore) &&
    !!item.timeseries &&
    item.timeseries.series !== undefined &&
    typeof item.timeseries.series === 'string' &&
    item.timeseries.field !== undefined &&
    typeof item.timeseries.field === 'string' &&
    item.timeseries.start !== undefined &&
    typeof item.timeseries.start === 'string' &&
    item.timeseries.end !== undefined &&
    typeof item.timeseries.end === 'string'
  )
}

export const getOptionsHeatmapData = async (
  source: Source,
  ticker: Ticker,
  model: Model,
  frequency: DataFrequency,
  date: Date | 'LATEST',
  signal?: AbortSignal,
): Promise<[OptionsHeatmapItem[], number]> => {
  let exchangeParam = source.toLowerCase()
  if (source === Source.BLOCKSCHOLES) {
    exchangeParam = 'v2composite'
  } else if (source === Source.V2LYRA) {
    exchangeParam = 'v2lyra'
  }
  const query: ModelParametersSpecifiedTimestampParams = {
    model,
    currency: ticker,
    exchange: exchangeParam,
    timestamp:
      date !== 'LATEST' ? (date.getTime() * 1000000).toString() : 'LATEST',
    frequency,
  }
  const urlSearchParams = new URLSearchParams(query)
  const [result, timestamp] = await getBSData(
    OPTIONS_HEATMAP_ENDPOINT,
    urlSearchParams,
    isOptionsHeatmapItem,
    signal,
  )
  if (!timestamp) {
    throw new Error("Couldn't retrieve timestamp for query")
  }

  // TODO Remove when data better
  return [result.filter((r) => r.expiry < 365), timestamp]
}
